<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <p class="s_c333 p-l-15 m-b-24">退款方式：{{refundsData.refund_type==0?"仅退款":"退货退款"}}</p>
      <p class="s_c333 p-l-15 m-b-24">退货数量：{{refundsData.goods_num}}</p>
      <p class="s_c333 p-l-15 m-b-24">退还积分：{{refundsData.refund_point_price}}</p>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="address_id" label="退货地址" name="address_id">
          <a-input v-model:value="form.name" placeholder='请选择退货地址' style="width:200px"/><a-button @click="showRefundList=true">选择</a-button>
        </a-form-item>
          <a-form-item ref="address_id" :wrapper-col="{offset:4}" name="address_id">
            <a href="/order/order_manage/return_address" target="_blank">新建退货地址</a>
           </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading='loading'>
            确定
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
      <a-modal  :keyboard="false" title="选择退款地址" v-model:visible="showRefundList" centered :width='1300' :footer="null" destroyOnClose>
        <selectRefundList v-on:select="addressSelect" :checkout="false"></selectRefundList>
    </a-modal>
  </a-layout>
</template>
<script>
import { ref, watchEffect, reactive, toRefs, inject } from 'vue';
import { getChannelRefundAudit } from '@/api/order';
import { message } from 'ant-design-vue';
import { iscode } from '@/utils/app';
// 初始化默认筛选项数值
let defForm = {
  // refund_amt: '',
  is_agree: 1,
  refuse_desc: '',
  name:'',
  address_id:'',
  refund_type: 1, //退款类型，
};
export default {
  name: 'refundsForem',
  components: {},
  props: {
    refundsData: {
      type: Object,
    },
    type: {
      type: String,
    },
    is_refund: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      refundsData: {},
      showRefundList:false,
      loading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      rules: {
        address_id: [{ required: true, message: '请选择退款地址' }],
      },
    });
    const ruleForm = ref();
    const _lodash = inject('_lodash');
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          state.loading = true;
           let res = await getChannelRefundAudit({
                address_id:form.value.address_id,
              refund_id: state.refundsData.refund_id,
              refund_type:1,
              remark:'',
              type:1
            })
              .then((res) => res.data)
              .catch((error) => error);
          if (iscode(res)) {
            emit('submitrefunds');
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
          state.loading = false;
        })
        .catch((error) => {
          message.error('请完善表单！');
        });
    };
    watchEffect(() => {
      var refundsData = props.refundsData || {};
      if (!_lodash.isEmpty(refundsData)) {
        state.refundsData = refundsData;
      }
    });
    const addressSelect=(data)=>{
        form.value.address_id=data.id
        form.value.name=data.name
        state.showRefundList=false
    }
    return {
      form,
      ...toRefs(state),
      ruleForm,
      addressSelect,
      onSubmit,
    };
  },
};
</script>